import { useTheme } from '@mui/material';

import { colors } from '@constants/colors';
import { useMytaverse } from '@providers/MytaverseProvider';
import { ScreenSizes } from '@interfaces';

export const useStyles = () => {
  const { appTheme } = useMytaverse();
  const { breakpoints } = useTheme();

  return {
    root: { position: 'relative', display: 'inline-flex', mt: 4 },
    content: {
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      position: 'absolute',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    indicator: {
      color: colors.grey_900,
      fontSize: 24,
      fontWeight: 600,
      lineHeight: 1.6,
    },
    progress: {
      border: `4px solid ${colors.grey_10}`,
      borderRadius: '50%',
      boxShadow: `0 3px 3px 0px ${colors.black}0D`,
      '& .MuiCircularProgress-circle': {
        strokeLinecap: 'round',
      },
      '&.MuiCircularProgress-root': {
        color: appTheme.mainColor,
        width: '120px !important',
        height: '120px !important',

        [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
          width: '96px !important',
          height: '96px !important',
        },
      },

      '& .MuiCircularProgress-svg': {
        m: -0.5,
      },
    },
  };
};
